export default "__VITE_ASSET__Ct_0AwY$__"